import { render } from "./VerticalLayout.vue?vue&type=template&id=e924d3a0&scoped=true"
import script from "./VerticalLayout.vue?vue&type=script&lang=js"
export * from "./VerticalLayout.vue?vue&type=script&lang=js"

import "./VerticalLayout.vue?vue&type=style&index=0&id=e924d3a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e924d3a0"]])

export default __exports__